import React, { Component } from "react";
import { connect } from "react-redux";

//MUI
import { withStyles } from "@material-ui/core/styles";

//Pages
import ClientLogPage from "./client_dashboard/ClientLogPage";

function mapStateToProps(state) {
  return {
    role: state.user.currentUser.role
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch
  };
}

const styles = theme => ({
  root: {
    flexGrow: 1
  }
});

class LogsRouter extends Component {
  render() {
    const { classes, role } = this.props;
    return <div className={classes.root}>{role === "client" ? <ClientLogPage {...this.props} /> : null}</div>;
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(LogsRouter));



// WEBPACK FOOTER //
// ./src/pages/LogsRouter.js